// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"_21PI2D7guLAIQANxvzYNJc","cancelBtn":"_3uXdXQvuqA3o0qZYCdCh9U","saveBtn":"_3tvQ9REFoq0VvMm8FRG77w"};